"use client";

export { Badge, badgeVariants } from "@repo/ui/badge";
export type { BadgeProps } from "@repo/ui/badge";
